import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllInterests,
  getUserIntersests,
  setUserIntersests,
  getAllInterestsPublic,
} from './thunks';
import { InterestsState } from './types';

export const name = 'interests';

const initialState: InterestsState = {
  data: [],
  userInterests: JSON.parse(
    localStorage.getItem('userInterests') || '[]'
  ),
  status: 'idle',
  userInterestsStatus: 'idle',
  setUserInterestsStatus: 'idle',
  allInterestsPublic: {
    data: [],
    status: 'idle',
  },
};

export const getAllInterestsAsync = createAsyncThunk(
  name + '/getAllInterests',
  getAllInterests
);

export const getUserInterestsAsync = createAsyncThunk(
  name + '/getUserInterests',
  getUserIntersests
);

export const setUserInterestsAsync = createAsyncThunk(
  name + '/setUserInterests',
  setUserIntersests
);

export const getAllInterestsPublicAsync = createAsyncThunk(
  name + '/getAllInterestsPublic',
  getAllInterestsPublic
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    setUserInterests: (state, action) => {
      state.userInterests = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllInterestsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllInterestsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllInterestsAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getUserInterestsAsync.pending, (state) => {
        state.userInterestsStatus = 'loading';
      })
      .addCase(getUserInterestsAsync.fulfilled, (state, action) => {
        state.userInterestsStatus = 'idle';
        state.userInterests = action.payload;
      })
      .addCase(getUserInterestsAsync.rejected, (state) => {
        state.userInterestsStatus = 'failed';
      })
      .addCase(setUserInterestsAsync.pending, (state) => {
        state.setUserInterestsStatus = 'loading';
      })
      .addCase(setUserInterestsAsync.fulfilled, (state) => {
        state.setUserInterestsStatus = 'idle';
      })
      .addCase(setUserInterestsAsync.rejected, (state) => {
        state.setUserInterestsStatus = 'failed';
      })
      .addCase(getAllInterestsPublicAsync.pending, (state) => {
        state.allInterestsPublic.status = 'loading';
      })
      .addCase(getAllInterestsPublicAsync.fulfilled, (state, action) => {
        state.allInterestsPublic = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getAllInterestsPublicAsync.rejected, (state) => {
        state.allInterestsPublic.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
